// Shim file used by esbuild's --inject flag. Replaces webpack's ProvidePlugin
// behaviour: any source file that references bare `_` or `moment` gets the
// matching import auto-prepended at bundle time.
import lodash from "lodash"
import momentLib from "moment"

export { lodash as _ }
export { momentLib as moment }
